import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Carousel from "@/components/helpers/Carousel.tsx";
import Section from "@/components/helpers/Section/Section.tsx";

import { Content } from "@/@types/general.ts";
import { useGetRecommends } from "@/hooks/api/content.hooks.ts";
import { useGetProfileDetail } from "@/hooks/api/user.hooks";

import RecMovieCard from "../cards/MovieCard/RecMovieCard";

const RecommendationSection = (): JSX.Element => {
  const { data: premiers } = useGetRecommends();

  const id = localStorage.getItem("splay:profileId");

  const { t } = useTranslation();

  const { data: profile, isError } = useGetProfileDetail(+id!);

  if (!premiers.length || !profile || isError) return <></>;

  return (
    profile && (
      <Section
        title={t("recommends", { value: `<span class="gradient-text">${profile.name}</span>` })}
        className={`group/section gap-6`}
      >
        <Carousel<Content>
          swiperParams={{
            spaceBetween: 16,
            breakpoints: {
              0: { slidesPerView: 1.2, slidesPerGroup: 1 },
              450: { slidesPerView: 2 },
              700: { slidesPerView: 3, spaceBetween: 12 },
              1480: { slidesPerView: 4, spaceBetween: 16 },
            },
          }}
          items={premiers}
          swiperName={"recommends"}
        >
          {(content, index) => <RecMovieCard key={content.id} {...content} index={index} />}
        </Carousel>
      </Section>
    )
  );
};

export default RecommendationSection;
